import axios, { AxiosInstance } from 'axios';
import { Product } from '@/models/Product';

export const SYSTEM_UKNOWN_ERROR_MESSAGE = '未知的錯誤，請聯絡系統管理員。';
export const SYSTEM_NETWORK_ERROR_MESSAGE = '網路錯誤，請檢查網路連線。';

export interface UpdateResult {
    product: Product;
    message: string;
}

export class ProductRepository {
    GET_BY_ID_URL = '/product/'

    private axiosInstance: AxiosInstance;

    constructor(baseURL: string) {
        this.axiosInstance = axios.create({
            baseURL: baseURL,
            headers: {
                'Content-Type': 'application/json'
            }
        });

    }

    public async getProductById(id: string): Promise<Product> {
        try {
            const response = await this.axiosInstance.get(this.GET_BY_ID_URL + id);
            return Product.fromJson(response.data);

        } catch (error) {
            if (error instanceof TypeError && error.message === 'Failed to fetch') {
                throw new Error(SYSTEM_NETWORK_ERROR_MESSAGE);
            }

            throw new Error(SYSTEM_UKNOWN_ERROR_MESSAGE);
        }
    }
}

export default ProductRepository;